import { render, staticRenderFns } from "./LookupField.vue?vue&type=template&id=8f54a384&"
import script from "./LookupField.vue?vue&type=script&lang=js&"
export * from "./LookupField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports